subscription TransactionDocumentPackageStatus($id: UUID!) {
  transactionDocumentPackageStatus(id: $id) {
    document {
      id
    }
    status
  }
}
